import React from 'react';
import { Route } from "react-router-dom";
import ContentViewComponent from './ContentViewComponent';

/**
 * Helper function that creates a Route component with content wrapped in ContentViewComponent
 * with appropriate settings based on the path
 */
const createContentRoute = ({ path, element, ...rest }) => {
  // Determine if this route should not shrink with file browser
  // Currently, only the songs view doesn't shrink
  const shouldNotShrink = path.startsWith('/songs');

  return (
    <Route
      key={path}
      path={path}
      element={
        <ContentViewComponent shrinkWithFileBrowser={!shouldNotShrink}>
          {element}
        </ContentViewComponent>
      }
      {...rest}
    />
  );
};

export default createContentRoute;
